import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Divider, Form, Input, Space } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/ImagePicker"
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
const service = new StoreSettingService();

const WebsiteSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        var setting = await service.getPrintSetting();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.savePrintSetting(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (


        <Form
            form={form}
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >

            <Divider>Hoá đơn</Divider>
            <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: 'Please input your website!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Mô tả"
                name="description"
                rules={[]}
            >
                <Input />
            </Form.Item>


            <Form.Item
                label="Hình ảnh"
                name="image"
                rules={[]}
            >
                <ImagePicker ></ImagePicker>
            </Form.Item>
            <Divider>Phiếu gửi hàng</Divider>

            <Form.Item
                label="Người gửi"
                name="sender_name"
                rules={[]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Số điện thoại người gửi"
                name="sender_phone"
                rules={[]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Ghi chú"
                name={"note"}
                rules={[]}
            >
                <Input />
            </Form.Item>









            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Cập nhật
                </Button>
            </Form.Item>
        </Form>
    )
}
export default WebsiteSetting;